/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
import { FaCoins } from 'react-icons/fa';
import { getSupportedTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
export var TotalSupply = createPlugin({
    protocol: 'ERC20',
    type: 'GETTER',
    method: 'totalSupply',
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({
                    destination: 'erc20',
                    options: getSupportedTokens({ chainId: chainId }),
                    isPreview: true,
                    icon: FaCoins,
                }),
                methodParams: {},
            },
            output: {
                totalSupply: new FctValue({ destination: 'wei_amount', innerIndex: 0 }),
            },
        });
    },
});
